module.exports = __webpack_public_path__ + "static/media/clock-icon.ecf58a84.svg";